<div class="content-section">
  <div class="titles-wrapper">
    <div class="title-container">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Color del texto</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colorText"
            [value]="tool.colorText"
            [style.background]="tool.colorText"
            [(colorPicker)]="tool.colorText" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Color del background</p>
        <div class="form-check form-switch d-flex align-items-center">
          <input
            class="input-colorpicker ms-2"
            [(ngModel)]="tool.colorBg"
            [value]="tool.colorBg"
            [style.background]="tool.colorBg"
            [(colorPicker)]="tool.colorBg" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="upload-file-container">
          <div
            class="file-content"
            *ngIf="!tool.data; else fileExisting"
            fileDropZone
            (fileDrop)="onFileDropped($event)">
            <p class="text-drag-file">Arrastra el archivo aquí</p>
            <p class="text-drag-file divisor">— o —</p>
            <input type="file" class="file-uploader" (change)="onFileSelected($event)" #fileUpload />
            <button class="upload-file-btn" (click)="fileUpload.click()">Seleccionar archivo de tu ordenador</button>
          </div>
          <a class="btn-transparent" [href]="downloadTemplate" download="discalimer_template.json">
            Descargar plantilla
          </a>
          <ng-template #fileExisting>
            <div class="file-content active">
              <div class="file-box">
                <span>{{ filename }}</span>
                <button class="element-action-btn" (click)="deleteDroppedFile()">
                  <img id="delete" alt="" />
                </button>
              </div>
              <div class="jsonviewer-wrapper" *ngIf="tool.data">
                <ngx-json-viewer *ngIf="tool.data" [json]="tool.data" [expanded]="false"></ngx-json-viewer>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
      <!-- <div class="d-flex align-items-center justify-content-between mb-3">
        <p>Disclaimer text list</p>
        <div class="d-flex align-items-center">
          <div id="createnew" class="btn-secondary-wrapper me-2">
            <button
              type="button"
              class="btn-action-icon"
              (click)="toggleGenerationMode('create')"
              [ngClass]="{ active: generationMode.mode === 'create' }">
              <img src="/assets/img/icons/plus-white.svg" />
            </button>
          </div>
          <div class="form-check form-switch">
            <input
              class="input-switch-sm form-check-input"
              type="checkbox"
              role="switch"
              [(ngModel)]="previewDisclaimer.show"
              [checked]="previewDisclaimer.show" />
          </div>
        </div>
      </div>
      <div [hidden]="!previewDisclaimer.show" class="disclaimer-preview-wrapper mt-4">
        <app-disclaimer-preview
          #previewitem
          [activeId]=""
          [list]="itemList"
          (updatedPositionItem)="moveItem($event)"
          (editedItem)="editItem($event)"></app-disclaimer-preview>
      </div> -->
    </div>
  </div>
  <div class="modal-wrapper" [ngClass]="{ slideup: generationMode.mode }">
    <div class="w-100 p-2">
      <!-- <app-disclaimer-create-edit
        *ngIf="generationMode.mode"
        [tool]="tool"
        [mode]="generationMode.mode"
        [disclaimerItems]="{ new: newDisclaimer, edit: itemToEdit }"
        (savedItem)="savedItem($event)"
        (cancelItem)="cancelItem($event)"></app-disclaimer-create-edit> -->
    </div>
  </div>
</div>
